import { Box, Grid, TextField, useMediaQuery, useTheme } from "@mui/material";
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import 'moment/locale/de';
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomActionBar from './CustomActionBar';
import MobileWheelTimePicker from './MobileWheelTimePicker';
import WheelTimePicker from './WheelTimePicker';

const StartDateOnlyView = ({ value, setValue, setStartValue, setEndDate, setEndValue, setUpdated }) => {

    const theme = useTheme();
    const belowsm = useMediaQuery(theme.breakpoints.down("sm"));

    const [startDate, setStartDate] = useState(moment());

    const [openStartDate, setOpenStartDate] = useState(false);

    const { t } = useTranslation();

    useEffect(() => {
        if (value !== undefined) {
            setStartDate(moment(value));
        };
        //eslint-disable-next-line
    }, [value])

    const setTime = (time) => {
        setStartDate(time);
        setValue(time);
        setStartValue(time);
        const endDate = moment(time).add(15, "minute");
        setEndDate(endDate);
        setEndValue(endDate);
    }

    return (
        <Fragment>
            <Grid
                item
                xs={3}
                sx={{
                    p: 1,
                    pb: 0,
                    ml: 1
                }}
            >
                <Grid container>
                    <Grid item xs={6.5}>
                        <DatePicker
                            label={t("startdate")}
                            format="DD.MM.YYYY"
                            value={startDate}
                            open={openStartDate}
                            onClose={() => { setOpenStartDate(false); }}
                            onChange={(newValue) => {
                                let endDate = moment(newValue).add(15, "minute");
                                if (newValue !== null) {
                                    setStartDate(newValue);
                                    setValue(newValue);
                                    setStartValue(newValue);
                                    setEndDate(endDate);
                                    setEndValue(endDate);
                                } else {
                                    setStartDate(value);
                                    setValue(value);
                                    setStartValue(value);
                                    endDate = moment(value).add(15, "minute");
                                    setEndDate(endDate);
                                    setEndValue(endDate);
                                }
                                if (setUpdated) {
                                    setUpdated(true);
                                }
                            }}
                            slots={{
                                actionBar: CustomActionBar,
                            }}
                            slotProps={{
                                textField: {
                                    onClick: () => { setOpenStartDate(!openStartDate) },
                                    inputProps: {
                                        readOnly: true
                                    },
                                    InputLabelProps: {
                                        shrink: true
                                    }
                                },
                                desktopPaper: {
                                    sx: {
                                        backgroundImage: "none"
                                    }
                                },
                                mobilePaper: {
                                    sx: {
                                        pt: 2,
                                        borderRadius: 6,
                                        backgroundImage: "none"
                                    }
                                },
                                toolbar: {
                                    hidden: true
                                }
                            }}
                        />
                        {/* <MobileCalendarOnlyPicker date={startDate} setDate={setStartDate} isStart={true} /> */}
                    </Grid>
                    <Grid item xs={5.5}>
                        {!belowsm ?
                            <Box sx={{ ml: 1.5 }}>
                                <WheelTimePicker label={t("time")} value={startDate} setValue={setTime} showIcon={true} setUpdated={setUpdated} />
                            </Box>
                            :
                            <MobileWheelTimePicker label={t("time")} time={startDate} setTime={setTime} haveMargin={true} centerText={true} setUpdated={setUpdated} />}
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                item
                xs={3}
                sx={{
                    p: 1,
                    pt: belowsm ? 0 : 2,
                    ml: 1,
                }}
            >
                <Grid container sx={{ display: belowsm ? "none" : "flex" }}>
                    <Grid item xs={6.5}>
                        <TextField variant="outlined" value={t("no-enddate")} fullWidth disabled />
                    </Grid>
                    <Grid item xs={5.5}>
                        <TextField variant="outlined" value="" disabled sx={{ ml: 1.5 }} />
                    </Grid>
                </Grid>
            </Grid>
        </Fragment>
    );

};

export default StartDateOnlyView;